import { useEffect, useState } from 'react';
import { fetchConfig, grantPreview } from './api/client';
import { ComingSoon } from './pages/ComingSoon';
import { LandingPage } from './pages/LandingPage';
import { useTheme } from './theme/ThemeProvider';

// Default to "gate ON" so the first paint is always the coming-soon page —
// no loading spinner, no flash of unstyled gate, no surprises if the API is
// cold-starting. The server decides whether we're unlocked (because the
// preview cookie is HttpOnly and not readable from JS).
export function App(): JSX.Element {
  const { mascot } = useTheme();
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      // 1. If the URL carries a preview token, exchange it for a cookie first.
      const url = new URL(window.location.href);
      const token = url.searchParams.get('preview');
      if (token) {
        const granted = await grantPreview(token).catch(() => false);
        if (granted && !cancelled) {
          url.searchParams.delete('preview');
          window.history.replaceState(null, '', url.pathname + url.search + url.hash);
        }
      }

      // 2. Ask the server whether this request is past the gate. Short timeout
      //    so a cold-starting API doesn't pin the user on a blank screen —
      //    we just stay on coming-soon if config is slow.
      try {
        const cfg = await fetchConfig();
        if (cancelled) return;
        if (cfg.unlocked) setUnlocked(true);
      } catch {
        // Conservative on any failure: stay on coming-soon.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return unlocked ? <LandingPage mascot={mascot} /> : <ComingSoon mascot={mascot} />;
}
